import { completeStage, selectStage } from '../redux/slices/stageSlice';
import {
	fetchPP,
	fetchTNC,
	getReservationPaymentInfo,
	saveTermsAndCondition,
	selectTnc,
} from '../redux/slices/termsAndConditions';
import {
	fetchPropertyInfo,
	fetchReservation,
	selectSession,
} from '../redux/slices/sessionSlice';
import React, { useEffect, useRef } from 'react';
import {
	selectPayment,
	setSkipPayment,
	setTotal,
} from '../redux/slices/paymentSlice';
import {
	selectSignature,
	submitSignature,
} from '../redux/slices/signatureSlice';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { DarkButton } from './dark-button';
import { DarkInfoCard } from './dark-info-card';
import { getNumberOfNightsBetweenDates } from './../utils';
import { LightTNCCard } from './light-tnc-card';
import Loading from './loading';
import { Modal } from 'react-bootstrap';
import { setSkipTnC } from '../redux/slices/termsAndConditions';
import Signature from './signature';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import useState from 'react-usestateref';
import useStateRef from 'react-usestateref';
import { useTranslation } from 'react-i18next';

// import { fetchTNC, selectTnc } from '../redux/slices/termsAndConditions';

const TnCPage = ({ setCurrentStep }) => {
	const { t } = useTranslation();
	const childComponentRef = useRef();
	const dispatch = useAppDispatch();
	const {
		logo,
		content,
		loading,
		error,
		logoPP,
		contentPP,
		loadingPP,
		errorPP,
		moreInfo,
		reservationDtl,
	} = useAppSelector(selectTnc);
	const [submit, setSubmit, submitRef] = useState(false);
	// const [checked, setChecked, checkedRef] = useState(false);

	const { stages, stage } = useAppSelector(selectStage);
	const [showTnC, setShowTnC] = useState(false);
	const [showPrivacy, setShowPrivacy] = useState(false);
	const [_, setIsEmpty, isEmptyRef] = useState(true);
	const { token, countries, reservation, propertyInfo, settings } =
		useAppSelector(selectSession);
	//const { signature } = useAppSelector(selectSignature);
	const [signature, setSignature] = useState(null);
	const [____, setButtonLoading, buttonLoadingRef] = useStateRef(false);
	//stages?.map((it) => console.log('stage##--' + JSON.stringify(it)));
	const { isPostComplete } = useAppSelector(selectSignature);
	const specificDataExists =
		stages.find((it) => it.stepCode === 'SEI05')?.isEnabled ?? false;
	// const { totalPayment, setTotalPayment } = useAppSelector(selectPayment);

	const enablePaymentSkip = settings?.find(
		(setting) =>
			setting.parameterName === 'EnablePaymentSkip' &&
			setting.parameterValue === 'true'
	);

	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (event) => {
		setIsChecked(event.target.checked);
	};

	const skipTnCFun = () => {
		dispatch(setSkipTnC(true));
	};

	const [requestCodeEnablepayment, setPaymentInfo] = useState(true);
	const handleClick = () => {
		//setSubmit(true);
		// if (token && reservation && submit && reservation?.PmsConfirmationNo) {
		// 	dispatch(
		// 		submitSignature({
		// 			token: token,
		// 			reservationId: reservation?.ReservationID,
		// 			confirmationNo: reservation?.PmsConfirmationNo,
		// 			signature: sigPadRef?.current
		// 				?.getTrimmedCanvas()
		// 				?.toDataURL('image/png'),
		// 			propertyCode: propertyInfo?.propertyCode ?? '', //added new
		// 		})
		// 	);
		// }
		//captureSignature(signature);
		dispatch(
			completeStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
				propertyCode: propertyInfo?.propertyCode ?? '', //added new
			})
		);

		// if (skipPayment) {
		// 	dispatch(setSkipPayment(true));
		// }
	};
	const captureSignaturePay = async () => {
		const signatureData = childComponentRef.current.captureSignature();
		setSignature(signatureData);
		console.log('-----------------------');
		console.log(signatureData);
		console.log('-----------------------');
		try {
			await dispatch(
				submitSignature({
					token: token,
					reservationId: reservation?.ReservationID,
					confirmationNo: reservation?.PmsConfirmationNo,
					signature: signatureData,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
			await dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			)
				.unwrap()
				.then(() => {
					dispatch(
						saveTermsAndCondition({
							token: token,
							reservationId: reservation?.ReservationID,
							confirmationNo: reservation?.PmsConfirmationNo,
							tnChecked: isChecked,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
						})
					);
				});
		} catch (er) {
			console.log(er);
			Swal.fire({
				title: 'Exception',
				text: 'Some error occured',
				icon: 'error',
			}).then(function () {
				console.log('invalid inputs');
				setButtonLoading(false);
			});
		}
	};

	const captureSignature = () => {
		const signatureData = childComponentRef.current.captureSignature();
		setSignature(signatureData);
		console.log('-----------------------');
		console.log(signature);
		console.log('-----------------------');
	};

	const captureSignatureSkipPay = async () => {
		try {
			const signatureData = childComponentRef.current.captureSignature();

			await dispatch(
				submitSignature({
					token: token,
					reservationId: reservation?.ReservationID,
					confirmationNo: reservation?.PmsConfirmationNo,
					signature: signatureData,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
			// if (isPostComplete === true) {
			// }
			await dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			)
				.unwrap()
				.then(() => {
					dispatch(
						saveTermsAndCondition({
							token: token,
							reservationId: reservation?.ReservationID,
							confirmationNo: reservation?.PmsConfirmationNo,
							tnChecked: isChecked,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
						})
					);
				});
			await dispatch(setSkipPayment(true));
		} catch (er) {
			console.log(er);
			Swal.fire({
				title: 'Exception',
				text: 'Some error occured',
				icon: 'error',
			}).then(function () {
				console.log('invalid inputs');
				setButtonLoading(false);
			});
		}
	};

	const skippaymentFun = () => {
		console.log('stage?.stepID--' + stage?.stepID);
		//setSubmit(true);

		// if (token && reservation && submit && reservation?.PmsConfirmationNo) {
		// 	dispatch(
		// 		submitSignature({
		// 			token: token,
		// 			reservationId: reservation?.ReservationID,
		// 			confirmationNo: reservation?.PmsConfirmationNo,
		// 			signature: sigPadRef?.current
		// 				?.getTrimmedCanvas()
		// 				?.toDataURL('image/png'),
		// 			propertyCode: propertyInfo?.propertyCode ?? '', //added new
		// 		})
		// 	);
		// }

		dispatch(
			completeStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
				propertyCode: propertyInfo?.propertyCode ?? '', //added new
			})
		);
		dispatch(
			submitSignature({
				token: token,
				reservationId: reservation?.ReservationID,
				confirmationNo: reservation?.PmsConfirmationNo,
				signature: signature,
				propertyCode: propertyInfo?.propertyCode ?? '', //added new
			})
		);
		dispatch(setSkipPayment(true));
	};
	// useEffect(() => {
	// 	console.log('you can log the new value here if the form is submitted');
	// 	console.log(signature);
	// 	if (signature === null || signature === undefined) {
	// 		setIsEmpty(true);
	// 	}
	// }, [signature]);

	useEffect(() => {
		if (token) {
			dispatch(fetchTNC(token));
			dispatch(fetchPP(token));
		}
	}, [token]);

	useEffect(() => {
		if (token && !propertyInfo) {
			dispatch(fetchPropertyInfo(token));
		}
	}, [token, JSON.stringify(propertyInfo)]);

	useEffect(() => {
		if (reservation?.PmsConfirmationNo && token) {
			dispatch(
				getReservationPaymentInfo({
					token,
					confirmationNo: reservation.PmsConfirmationNo,
					reservationNameID: reservation.ReservationNameID,
					propertyCode: propertyInfo?.propertyCode,
				})
			);
		}
	}, [reservation?.PmsConfirmationNo, token]);

	useEffect(() => {
		if (error.fetchContent) toast.error('Failed to fetch terms and conditions');
	}, [error.fetchContent]);

	// useEffect(() => {
	// 	if (
	// 		token &&
	// 		reservation &&
	// 		submit &&
	// 		reservation?.PmsConfirmationNo &&
	// 		isChecked
	// 	) {
	// 		dispatch(
	// 			saveTermsAndCondition({
	// 				token: token,
	// 				reservationId: reservation?.ReservationID,
	// 				confirmationNo: reservation?.PmsConfirmationNo,
	// 				tnChecked: isChecked,
	// 				propertyCode: propertyInfo?.propertyCode ?? '', //added new
	// 			})
	// 		);
	// 	}
	// }, [submit, reservation?.PmsConfirmationNo]);

	//CR-635 Paymnet blocking based on request code

	const checkRequestCode = (reservationDetailsResponse, blcAmount) => {
		try {
			const settingsList = settings;

			const requestCode = settingsList.find(
				(x) => x.parameterName === 'EngagePreferenceRequestCode'
			);
			if (requestCode != undefined || requestCode != null) {
				const requestCodeValue = requestCode?.parameterValue;
				if (requestCodeValue == '') {
					if (blcAmount > 0) {
						return true;
					} else {
						return false;
					}
				}
				const operaSpecials = reservationDetailsResponse?.specials;

				// If specials is not an array or is empty, return false
				if (operaSpecials.length === 0) {
					return false;
				}
				const hasMarketCode = reservationDetailsResponse?.specials?.some(
					(item) => item.code === requestCodeValue
				);
				//if prefernce request code avaliable do payment else skip payment
				if (hasMarketCode) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		} catch (error) {
			console.error('Failed to check payment eligibility', error);
			return true;
		}
	};

	const numberOfNights = getNumberOfNightsBetweenDates(
		new Date(reservation?.ArrivalDate),
		new Date(reservation?.DepartureDate)
	);

	const [totalAmountDue, setTotalAmountDue] = useState(null);

	useEffect(() => {
		const calcTotal = parseFloat(reservationDtl?.totalAmountDue ?? 0).toFixed(
			2
		);
		setTotalAmountDue(calcTotal < 0 ? 0 : calcTotal);
		if (reservationDtl) {
			var enablePayment = checkRequestCode(
				reservationDtl,
				calcTotal < 0 ? 0 : calcTotal
			);
			//alert(enablePayment);
			setPaymentInfo(enablePayment);
		}
	}, [reservationDtl]);

	return ((loading || loadingPP) && totalAmountDue === null) ||
		totalAmountDue === undefined ||
		reservationDtl === null ||
		reservationDtl === undefined ? (
		<Loading />
	) : (
		<div
			className="d-flex flex-column gap-4 vh-100 mx-auto"
			style={{ paddingBottom: '110px', overflow: 'auto' }}>
			<div
				className="d-flex flex-column justify-content-center align-items-center w-100 text-white theme-header"
				style={{ background: '#03355C', minHeight: '80px' }}>
				<p className="fs-2 m-0">{t('SignaturePageHeader')}</p>
			</div>
			<img
				className="theme-header-img"
				src={process.env.PUBLIC_URL + '/logo-header.svg'}></img>
			<div
				className="d-flex flex-column gap-4 px-2 pt-2 mx-auto"
				style={{ maxWidth: '1200px' }}>
				<div className="d-flex flex-column gap-3 justify-content-around align-items-center w-100 text-center">
					<h1
						className="m-0 fs-2 fw-semibold text-center"
						style={{ color: '#03355C' }}>
						{t('SignaturePageSubHeader')}
					</h1>
					{/* <div>
						<p className="m-0 fs-2">
							Room Rate:{' '}
							<span className="fw-bold">${reservation?.RateCodeAmount}</span>
						</p>
						<p className="m-0 fs-2">
							Package:{' '}
							<span className="fw-bold">${reservation?.Package ?? 0}</span>
						</p>
					</div> */}
					<DarkInfoCard
						confirmationNumber={reservation?.PmsConfirmationNo}
						cardFields={[
							{
								title: t('SignaturePageNumberOfNights'),
								description: numberOfNights,
								textStyle: 'bold',
								span: 6,
							},
							{
								title: t('SignaturePageDailyRomRate'),
								description:
									reservationDtl?.printRate == false
										? '-'
										: `${propertyInfo?.currency ?? ''} ${parseFloat(
												reservationDtl?.rateCodeAmount ?? 0
										  ).toFixed(2)}`,
								textStyle: 'Bold',
								span: 6,
							},
							{
								title: t('SignaturePageTotalCharge'),
								description:
									t('SignaturePageTotalCharge').trim() === ''
										? ''
										: `${propertyInfo?.currency ?? ''} ${(
												reservationDtl?.numberOfNights ??
												1 *
													parseFloat(
														reservationDtl?.totalRoomRateAndPackages ?? 0
													)
										  ).toFixed(2)}`,
								textStyle: 'Bold',
								span: 6,
							},
							{
								title: t('SignaturePageTotalAmount'),
								description: `${propertyInfo?.currency ?? ''} ${
									totalAmountDue
									// reservation?.BalanceAmount ?? 0
									// reservation?.numberOfNights ??
									// 1 * reservation?.RateCodeAmount ??
									// 0
								}`,
								textStyle: 'Bold',
								span: 6,
							},
						]}
					/>
					{/* <div>
						<p className="m-0 mt-2 fs-2 fw-bold">Total Amount due:</p>
						<p className="m-0 fs-2 fw-bold">
							${reservation?.RateCodeAmount + (reservation?.Package ?? 0)}
						</p>
					</div> */}
				</div>

				<div className="d-flex flex-column gap-3 justify-content-around align-items-center w-100 theme-tnc">
					<p
						className="px-2 m-0 fs-6 lh-sm"
						style={{
							textAlign: 'justify',
							maxWidth: '1000px',
						}}>
						{content?.length > 0 ? content[0].moreInfo : ''}
					</p>

					<h1 className="fs-6 fw-semibold text-center px-2 m-0">
						{t('SignaturePageMessage1')}
						<button
							id="btn-SignaturePageMessage2"
							onClick={() => setShowTnC(true)}
							style={{
								all: 'unset',
								color: 'inherit',
								whiteSpace: 'nowrap',
								cursor: 'pointer',
								textDecoration: 'underline',
							}}>
							{t('SignaturePageMessage2')}
						</button>
						<label style={{ marginLeft: '5px' }}>
							{t('SignaturePageMessage3')}
						</label>
						<button
							id="btn-SignaturePageMessage4"
							onClick={() => setShowPrivacy(true)}
							style={{
								all: 'unset',
								color: 'inherit',
								whiteSpace: 'nowrap',
								cursor: 'pointer',
								textDecoration: 'underline',
								marginLeft: '5px',
							}}>
							{t('SignaturePageMessage4')}
						</button>
					</h1>

					<div className="p-0 w-100">
						<Signature
							ref={childComponentRef}
							submit={submit}
							setIsEmpty={setIsEmpty}
							setSignature={setSignature}
							captureSignature={captureSignature}
						/>
					</div>
					<div
						className="p-0 mb-1 theme-tnc-checkbox"
						style={{
							background: '#1f315a',
							color: 'white',
							padding: '5px 10px 5px 5px',
							borderRadius: '5px',
							textAlign: 'center',
						}}>
						{t('SignaturePageCheckBoxMessage1').trim() === '' ? (
							<br></br>
						) : (
							<>
								<input
									id="checkbox-tnc-msg1or2"
									type="checkbox"
									className="form-check-input"
									checked={isChecked}
									onChange={handleCheckboxChange}
								/>{' '}
								{t('SignaturePageCheckBoxMessage1')}
								{propertyInfo?.property ?? ''}
								{t('SignaturePageCheckBoxMessage2')}
							</>
						)}
					</div>
				</div>
			</div>
			{/* <div className="container mt-1 mb-3">
				<div className="container">
					<LightTNCCard logo={logo} content={content} />
				</div>
				<div className="fixed-bottom w-100">
					<form className="mt-5 w-100">
						<div className="d-flex flex-row gap-3 px-5 py-4 justify-content-center align-items-start w-100">
							<img
								src={checked ? 'checked.svg' : 'unchecked.svg'}
								alt="checkbox"
								style={{ cursor: 'pointer' }}
								onClick={checkboxClicked}
							/>
							<p className="m-0" style={{ fontSize: '0.85rem' }}>
								By checking this box, I agree to receive marketing emails.
							</p>
						</div>
					</form>
					<div
						className="px-5 pb-4 pt-1 border-top d-flex flex-row justify-content-center"
						style={{ backgroundColor: 'white', borderColor: 'gray' }}>
						<DarkButton
							text={'Agree & Sign'}
							onClick={() => setCurrentStep('Sign')}
							filled={true}
						/>
					</div>
				</div>
			</div> */}
			<div
				className="fixed-bottom d-flex flex-row justify-content-center button-group pb-4 px-2 border-top gap-4 theme-footer"
				style={{
					backgroundColor: 'white',
					borderColor: 'gray',
				}}>
				{totalAmountDue !== null && totalAmountDue !== undefined && (
					<>
						<DarkButton
							text={
								totalAmountDue <= 0 ||
								specificDataExists === false ||
								enablePaymentSkip
									? t('SignaturePageButton3')
									: t('SignaturePageButton1')
							}
							onClick={() => captureSignatureSkipPay()}
							disabled={isEmptyRef.current}
						/>
						<DarkButton
							text={t('SignaturePageButton2')}
							onClick={() => captureSignaturePay()}
							filled
							disabled={isEmptyRef.current}
							hidden={
								totalAmountDue <= 0 ||
								!requestCodeEnablepayment ||
								specificDataExists == false
							}
						/>
					</>
				)}

				{/* <button onClick={() => captureSignature()}>Capture Signature</button> */}
			</div>
			<Modal
				centered
				backdrop={true}
				show={showTnC}
				onHide={() => setShowTnC(false)}
				contentClassName="tnc-modal-content">
				<Modal.Header closeButton>
					<Modal.Title>Terms & Conditions</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<LightTNCCard
						logo={logo}
						content={content}
						loading={loading}
						isStatic={false}
					/>
				</Modal.Body>
			</Modal>
			<Modal
				centered
				backdrop={true}
				show={showPrivacy}
				onHide={() => setShowPrivacy(false)}
				contentClassName="tnc-modal-content">
				<Modal.Header closeButton>
					<Modal.Title>Privacy Policy</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{}}>
					<LightTNCCard
						logo={logoPP}
						content={contentPP}
						loading={loading}
						isStatic={true}
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default TnCPage;
